import styled from 'styled-components';

export const SDatetimeWrapper = styled.div<{ withTime: boolean }>`
  width: ${({ withTime }) => (withTime ? '100%' : 'auto')};

  & > div {
    padding: ${({ withTime }) => (withTime ? '14px' : '12px 0')};
  }

  .react-datepicker__sr-only {
    display: none;
  }
`;
